import type { IconSvgObject } from './types';

const RecordIcon: IconSvgObject = [
  ["circle", { cx: "12", cy: "12", r: "8", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default RecordIcon;
